import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxPrintElementService } from 'ngx-print-element';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AlertesService } from '../../services/public/alertes.service';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss']

})
export class QrCodeComponent {
data:any
  constructor(private modalService: BsModalService,
      public options: ModalOptions,
      private bsModalRef: BsModalRef,
      private ngxService: NgxUiLoaderService,
      public print: NgxPrintElementService,
      private alerte:AlertesService,
      public sanitizer : DomSanitizer
    ){
      this.data = options.initialState.url
     
  
  
    
  }

  closeModal(){
    this.bsModalRef.hide()
  }

  copyToClipboard() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.data).then(() => {
        this.alerte.warningNotification('URL','URL copiée !')
      }, () => {
        this.alerte.warningNotification('URL','Erreur lors de la copie.!')
      });
    } else {
      // Fallback pour les anciens navigateurs
      const textarea = document.createElement('textarea');
      textarea.value = this.data;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand('copy');
        this.alerte.warningNotification('URL','URL copiée !')
      } catch (err) {
        this.alerte.warningNotification('URL','Erreur lors de la copie.!')
      }
      document.body.removeChild(textarea);
    }
  }

  openInNewTab() {
    // OPEN URL IN NEW PAGE
    window.open(this.data, '_blank');
  }

}
